export var ApiRateLimitAlgorithmEnum;
(function (ApiRateLimitAlgorithmEnum) {
    ApiRateLimitAlgorithmEnum["BURST_ALLOWANCE"] = "burst_allowance";
    ApiRateLimitAlgorithmEnum["WINDOW_DURATION"] = "window_duration";
})(ApiRateLimitAlgorithmEnum || (ApiRateLimitAlgorithmEnum = {}));
export class IApiRateLimitAlgorithm {
}
ApiRateLimitAlgorithmEnum.BURST_ALLOWANCE, ApiRateLimitAlgorithmEnum.WINDOW_DURATION;
